import { isString, isObject, isEmpty, isNil } from "lodash";
import * as funcParser from "./func";

/**
 * 校验
 * @param {object} params 请求参数
 */
export const validate = (params) => {
  if (!isObject(params)) {
    return {
      success: false,
      errorMsg: `${params} 请求参数须为对象`,
    };
  }

  return {
    success: true,
    errorMsg: "",
  };
};

/**
 * 解析请求参数
 * @param {string} params 请求参数
 * @return {object} { handler }
 */
export const parse = (params = {}, options = {}) => {
  const { fieldApi } = options;

  const validateResult = validate(params);
  console.warn(validateResult.success, validateResult.errorMsg);

  // 目前只支持值变更
  const event = {};
  Object.keys(params).forEach((key) => {
    if (isString(params[key]))
      (params[key].match(/(\${([^}]*)})/g) || []).forEach((item) => {
        const fieldId = item.match(/(\${([^}]*)})/)[2];
        if (!event[fieldId]) event[fieldId] = ["change"];
      });
  });
  return {
    event,
    handler: ({
      allowEmptyParam = false,
      allowedEmptyParams = [],
      emptyStringAsNull = false,
      convertFlag = true,
      ignoreError = false,
    } = {}) => {
      const result = {};
      const realAllowEmptyParam =
        allowEmptyParam || !isEmpty(allowedEmptyParams);
      let notExisted = false; // 字段是否不存在
      let inValid = false; // 字段校验结果
      let nullExisted = false; // 是否包含空值
      // 滤除未在页面显示的字段
      if (!realAllowEmptyParam) {
        Object.keys(event).some((fieldId) => {
          if (!fieldApi.isFieldExist(fieldId)) {
            notExisted = true;
            return true;
          }
          if (!ignoreError && fieldApi.hasFieldError(fieldId)) {
            inValid = true;
            return true;
          }
          return false;
        });
      }

      if (notExisted || inValid) return null;
      Object.keys(params).forEach((key) => {
        const template = params[key];
        if (isString(template)) {
          result[key] = funcParser.parse(template, {
            ...options,
            convertFlag,
          })();
        } else {
          result[key] = template;
        }

        if (
          realAllowEmptyParam &&
          (isEmpty(allowedEmptyParams) || allowedEmptyParams.indexOf(key) > -1)
        ) {
          // 如果允许空参数，或者允许的空参数列表中有指定字段的key，则不会抛出 nullExisted
        } else if (
          isNil(result[key]) ||
          (emptyStringAsNull && result[key] === "")
        ) {
          nullExisted = true;
        }
      });

      // 如果有字段不存在，置为 null
      // eslint-disable-next-line no-nested-ternary
      return nullExisted ? null : result;
    },
  };
};
